import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { EmployeeListPage } from '@/features/org/components/employee-list-page'
import { EMPLOYEES_SEARCH_DEFAULTS, employeesSearchSchema } from '@/features/org/search-schema'

/**
 * /employees —— 员工管理(组织维护视角)。
 *
 * 筛选(团队 / 在职状态 / 关键词)、排序、分页全部走 search params(zod 校验,非法值降级而不是白屏),
 * 等于默认值的参数由 stripSearchParams 摘掉(A4),裸 /employees 就是干净首屏。
 * 新建 / 编辑是同级的独立路由页(不是弹窗)——冷加载 `/employees/new?team=…` 也能还原。
 * 页面实现见 features/org/。
 */
export const Route = createFileRoute('/_authed/employees/')({
  validateSearch: employeesSearchSchema,
  search: {
    middlewares: [stripSearchParams(EMPLOYEES_SEARCH_DEFAULTS)],
  },
  component: EmployeeListPage,
})
